import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { firstValueFrom } from "rxjs";
import { ConfigService } from "./config.service";

@Injectable()
export class ApicService {
  
  ttocPath: string;
  apiPath: string;
  xIBMClientId: string;
  revokePath: string;

  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, @Inject(ConfigService) private configService: ConfigService,
    @Inject(HttpClient) private httpClient: HttpClient) {
    this.ttocPath = this.configService.appConfig.apic.baseUrl + this.configService.appConfig.apic.ttocPath;
    this.apiPath = this.configService.appConfig.apic.baseUrl + this.configService.appConfig.apic.apiPath;
    this.revokePath = this.configService.appConfig.apic.baseUrl + this.configService.appConfig.apic.revokePath;
    this.xIBMClientId = this.configService.appConfig.apic.xIBMClientId;
  }

  ttoc(accessToken: string): Promise<any> {

    type PostData = {
      access_token: string;
    }
    const postData: PostData = {
      access_token: accessToken
    };

    return firstValueFrom(this.httpClient.post(this.ttocPath, postData));
  }
}
